module.exports = __webpack_public_path__ + "img/98332E_4A100D_691A16_A85A5B-256px.99edc011.png";